import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MODULES_CONFIGURATION_TOKEN, ModulesConfiguration } from './tokens';

@NgModule({
  imports: [CommonModule]
})
export class SharedUtilModuleManagerModule {
  static forRoot(configuration: ModulesConfiguration): ModuleWithProviders {
    return {
      ngModule: SharedUtilModuleManagerModule,
      providers: [
        {
          provide: MODULES_CONFIGURATION_TOKEN,
          useValue: configuration
        }
      ]
    };
  }
}
